import { gql } from "@apollo/client";

export default gql`
  mutation unpublishAnnouncement($input: PublishChangelogInput!){
    unpublishAnnouncement(input: $input){
        success
        data{
            _id
            categoryId
            coverImageUrl
            channels
            status
            translations
            scheduledAt
            publishedAt
            sendStats
            reactionCount
            reactionAvg
            createdBy
            updatedBy
            createdAt
            updatedAt
            category{
                _id
                color
                translations
                createdAt
                updatedAt
            }
            myReaction
            myReactionComment
        }
        error
        message
    }
}
`
